import { Box, Typography } from '@mui/material';
import { InfoIcon } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';

const ConsentsDisclaimer = () => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        gap: 1,
        padding: 2,
        borderRadius: 1.5,
        backgroundColor: '#B9C4D1',
        width: '100%',
        boxSizing: 'border-box',
        alignSelf: 'flex-start',
      }}
    >
      <Box
        sx={{
          flexShrink: 0,
          display: 'flex',
          alignItems: 'center',
          maxWidth: '24px',
        }}
      >
        <InfoIcon size={20} weight="fill" />
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          flex: 1,
          maxWidth: 'calc(100% - 28px)',
        }}
      >
        <Typography
          component="p"
          variant="bodyMedium"
          fontWeight={400}
          sx={{
            margin: 0,
            padding: 0,
            lineHeight: '1.4',
            fontSize: '14px',
          }}
        >
          {t('enrollmentAgreementWelcome.message')}
        </Typography>
        <Typography
          component="p"
          variant="bodyMedium"
          fontWeight={700}
          sx={{
            margin: 0,
            padding: 0,
            lineHeight: '1.4',
            fontSize: '14px',
          }}
        >
          {t('enrollmentAgreementWelcome.pleaseRead')}
        </Typography>
      </Box>
    </Box>
  );
};

export default ConsentsDisclaimer;
